<script setup lang="ts">
// Lane C1 — richer pause/resume treatment.
//
// The banner itself is the persistent shell-level signal that an
// auction is paused (sits in the transient-banner stack below
// ContextStrip). It uses PrimeVue Message under CircuitPreset so the
// severity styling stays consistent with the rest of the bidder's
// status surfaces.
//
// The other half of the pause treatment lives at the action surfaces:
//   - BidCard.vue disables its Bid CTA + tooltips "Paused. Bids will
//     accept on resume." when isPaused.
//   - BidSheet.vue surfaces an in-sheet Message + disables submit.
//
// Together those three surfaces are the "richer than a pill" target
// from the design guide §10 Lane C1 scope. When the event resumes,
// every surface snaps back to normal automatically — the banner
// disappears, the CTA re-enables, the submit unblocks.
import { computed } from 'vue';
import Message from 'primevue/message';

import { useAuctionEvent } from '@/shell/stores/auctionEvent';

const auctionEvent = useAuctionEvent();
const isPaused = computed(() => auctionEvent.event?.isPaused === true);
</script>

<template>
  <Message
    v-if="isPaused"
    severity="warn"
    :closable="false"
    icon="pi pi-pause-circle"
    class="event-paused"
    data-testid="event-paused-banner"
  >
    Bidding paused. The auction will resume shortly.
  </Message>
</template>

<style scoped>
.event-paused {
  margin: 0;
  border-radius: 0;
}
.event-paused :deep(.p-message-wrapper) {
  /* Keep the banner aligned with the content well horizontally. */
  max-width: var(--app-well-max-width, 480px);
  margin: 0 auto;
}
</style>
